import React from 'react'
import Paragraph from './Paragraph'

const Requirements = () => {
  return (
    <div className='requirements-wrap'>
        <Paragraph variant="lead" content="What You Need for Verification" />
        <Paragraph content="Getting verified on FinditZ is simple and straightforward. Just submit your business registration documents, including:" />
        <div className='grid'>
            <div className='item'>
                <div>
                    <img src="https://finditzstg.wpengine.com/wp-content/uploads/2024/11/drivers-license.jpg" alt="Driver's License" />
                    <div className='text-wrap'>
                        <span>State Issued Photo ID</span>
                        <span>(Driver’s License or Passport)</span>
                    </div>
                </div>
            </div>
            <div className='item'>
                <div>
                    <img src="https://finditzstg.wpengine.com/wp-content/uploads/2024/11/tax-id.jpg" alt="Federal Tax ID" />
                    <div className='text-wrap'>
                        <span>Federal Tax ID Paperwork</span>
                    </div>
                </div>
            </div>
        </div>
        <Paragraph content="Once verified, you’ll immediately unlock your trust badge and new features that will help take your business to the next level." />
    </div>
  )
}

export default Requirements